<div class="container-section">
  <form (ngSubmit)="update(editForm)" #editForm="ngForm" maxLtvValidator minPropertyValueValidator
    [lendingType]="lendingType" interestOnlyAmountValidator interestOnlyEquityValidator mortgageTermValidator>
    <div>
      <div>
        <div>
          <h1 class="pt-4 mt-2 quick-edit-title">Quick Edit</h1>
        </div>
        <div>
          <h2 class="font-weight-bold mt-4">Property & Loan details</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6">
          <div class="form-group">
            <label for="propertyValue" class="font-weight-bold">Property Value</label>
            <div class="input-group" [class.is-invalid]="invalid(propertyValue)">
              <span class="input-group-text">£</span>
              <input type="text" class="form-control form-control-lg" id="propertyValue" required
                [(ngModel)]="model.propertyAndLoan.propertyValue" name="propertyValue" [greaterThan]="0"
                #propertyValue="ngModel" currencyMask [class.is-valid]="valid(propertyValue)"
                [class.is-invalid]="invalid(propertyValue)" aria-describedby="propertyValueError" />
            </div>
            @if (invalid(propertyValue)) {
              <div class="invalid-feedback alert alert-danger mt-2 d-flex"
                [style.display]="'block'">
                <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
                <span class="ms-3">
                  Property value must be greater than £0
                </span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <div class="form-group">
            <label for="loanAmount" class="font-weight-bold">How much would you like to borrow?</label>
            <div class="input-group" [class.is-invalid]="invalid(loanAmount)">
              <span class="input-group-text">£</span>
              <input type="text" class="form-control form-control-lg" id="loanAmount" required
                [(ngModel)]="model.propertyAndLoan.loanAmount" name="loanAmount" [greaterThan]="9999"
                greaterThanErrorKey="minLoanSize" #loanAmount="ngModel" [class.is-valid]="valid(loanAmount)"
                [class.is-invalid]="invalid(loanAmount)" aria-describedby="loanAmountError" currencyMask />
            </div>
            @if (invalid(loanAmount)) {
              <div class="invalid-feedback alert alert-danger mt-2 d-flex"
                [style.display]="'block'">
                <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
                <span class="ms-3">
                  {{ getErrorMessage(loanAmount) }}
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-2 results-btn-group-1">
      <button type="button" class="btn btn-outline-dark btn-lg buttons-container-margin-right d-flex justify-content-center"
        (click)="editAll()">
        <i class="icon-edit me-1"></i>
        <span class="btn-text">Edit All</span>
      </button>
      <button type="button" class="btn btn-outline-dark btn-lg ms-2 ms-md-4 d-flex justify-content-center" (click)="newSearch()">
        <i class="icon-search me-1"></i>
        <span class="btn-text">Start Again</span>
      </button>
    </div>
    <div class="d-flex mt-5 results-btn-group-2">
      <button type="submit" class="btn btn-primary btn-lg">
        <i class="fas fa-redo me-1"></i>
        Update Results
      </button>
      @if (isIntermediaryChannel) {
        <button type="button" (click)="printModal()"
          class="btn btn-outline-dark buttons-container-margin-right btn-lg ms-4 d-flex justify-content-center">
          <i class="icon-download me-1"></i>
          <span class="btn-text">Download my calculations</span>
        </button>
      }
    </div>
  </form>

  <ng-template #errorTemplate let-field="field" let-errorId="errorId">
    @if (invalid(field)) {
      <div class="invalid-feedback" [id]="errorId">
        {{ getErrorMessage(field) }}
      </div>
    }
  </ng-template>

  <ng-template #printModalTemplateRef>
    <div>
      <div class="row">
        <p>Please select which pages you would like to download</p>
      </div>
      <div class="row">
        <input type="checkbox" id="printResults" [(ngModel)]="affordabilityService.printResults">
        <label for="printResults" class="my-auto ms-2">Calculator Input</label>
      </div>
      <div class="row">
        <input type="checkbox" id="printInputs" [(ngModel)]="affordabilityService.printInputs">
        <label for="printInputs" class="my-auto ms-2">Calculator Results</label>
      </div>
    </div>
    <div class="row mt-3">
      <button class="btn btn-primary col-3" (click)="close()">Cancel</button>
      <button class="btn btn-primary col-3 offset-md-6"
        [disabled]="!affordabilityService.printInputs && !affordabilityService.printResults" (click)="print()">
        Print
      </button>
    </div>
  </ng-template>
</div>